// CSS 样式字符串（由 rollup 插件在打包时注入实际内容）
export const CSS = ''